import React from "react";

const Footer = () => {
  return (
    <footer className="w-full text-center py-4 text-gray-500 text-sm bg-transparent">
      Powered by{" "}
      <span className="font-semibold text-[#092162]">
        4A Consulting LLC
      </span>
    </footer>
  );
};

export default Footer;